import React from 'react';
import PropTypes from 'prop-types';
import styles from '../header.scss';
import { t } from '../../../services/i18nService';
import navigationService from '../../../services/NavigationService';
import a11yIIBScreenReaderService from '../../../services/a11yIIBScreenReaderService';
import HeaderA11yService from '../../../services/HeaderA11yService';

const OptionsMenuButton = ({ ui, isDisabled }) => {
    const isA11yIterationForIIBScreenReaderEnabled = a11yIIBScreenReaderService.isA11yIterationForIIBScreenReaderSupported();
    const fontIcon = ui.variables.header__optionsAnchorIcon;
    const {
        ariaLabel: optionsButtonAriaLabel,
        ariaKeyshortcuts: optionsButtonAriaKeyshortcuts,
    } = HeaderA11yService.getOptionsMenuButtonAttributes(isA11yIterationForIIBScreenReaderEnabled);

    return (<button
        className={styles.optionsButton}
        id="optionsMenuButton"
        onClick={navigationService.navigateToOptions}
        disabled={isDisabled}
        {...(optionsButtonAriaLabel && { 'aria-label': optionsButtonAriaLabel })}
        {...(optionsButtonAriaKeyshortcuts && { 'aria-keyshortcuts': optionsButtonAriaKeyshortcuts })}
    >
        <span className={styles.icon}>
            <span className="sr-only">{t('options.optionsHeader')}</span>
            <i className={`fa ${fontIcon} fa-3`} aria-hidden="true" />
        </span>
    </button>);
};

OptionsMenuButton.propTypes = {
    ui: PropTypes.object,
    isDisabled: PropTypes.bool.isRequired,
};

export default OptionsMenuButton;
